export default __webpack_public_path__ + "static/media/Ecommerce.02f53bf2.png";